<template>
  <div class="full-width full-height">
    <span class="body-1 page__pagination">
      {{ currentDate }} - Página {{ page }}/{{ totalPages }} | {{ rateModelDesc && rateModelDesc.key ? rateModelDesc.key : 'Desconocido' }}
      | V.{{ version }}
    </span>
    <img v-if="logo" :src="require('@/assets/footer.png')" class="page__footer" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'Footer',
  props: {
    page: {
      type: Number,
      default: 0,
    },
    logo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      totalPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    ...mapState('process', ['pdfTotalPages']),
    rateModelDesc(){
      return this[GET_OFFER_ITEM]('rateModelDesc')
    },
    version() {
      return this[GET_OFFER_ITEM]('finalVersion')
    },
    currentDate() {
      const date = new Date()
      const locale = 'es-ES'
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
      return date.toLocaleDateString(locale, options)
    },
  },
  mounted() {
    // HACK: access the store here so every PDF component has been
    // already created and has sent its number of pages
    this.totalPages = this.pdfTotalPages
  },
}
</script>
